import React from 'react';

import CheckedImgSrc from 'assets/icons/checked-blue.svg';

type Props = {
  onClick?: () => void;
};

export default function DoneButton(props: Props) {
  return (
    <div className="absolute right-0 bottom-0 p-4" onClick={props.onClick}>
      <div className="bg-skyblue rounded-lg cursor-pointer">
        <img
          src={CheckedImgSrc}
          alt="Done"
          className="p-3"
          style={{fill: 'black'}}
        />
      </div>
    </div>
  );
}
